<template>
  <div>
    <q-card class="success-dialog-container">
      <q-card-section class="row items-center dialog-title-wrapper">
        <div class="ibf-h1">
          <div class="title">{{ template.dialogTitle }}</div>
        </div>
      </q-card-section>
      <q-card-section class="row items-center dialog-body-wrapper">
        <h6
          class="ibf-amount2 app_text_grey"
          v-html="template.body"
        ></h6>
      </q-card-section>
      <q-card-section
        v-if="template.bodyIcon !== false"
        class="row items-center dialog-body-wrapper icon-container"
      >
        <img :src="successIcon" />
      </q-card-section>
      <q-card-actions
        class="action-wrapper"
        align="center"
      >
        <q-btn
          v-if="template.cancelLabel"
          v-close-popup
          class="dialog-btn cancel-btn incredi-button-ibx secondary"
          :label="template.cancelLabel"
          no-caps
          flat
          rounded
          @click="cancelClicked"
        />
        <q-btn
          v-if="template.okLabel"
          v-close-popup
          class="dialog-btn ok-btn incredi-button-ibx primary-strong"
          :label="template.okLabel"
          no-caps
          flat
          rounded
          @click="okClicked"
        />
      </q-card-actions>
      <div class="bottom-gradient">
        <div class="bottom-gradient1"></div>
        <div class="bottom-gradient2"></div>
      </div>
    </q-card>
  </div>
</template>

<script>
import successIcon from '@/assets/images/dialog-boxes/DialogSuccessIcon.svg';

export default {
  props: {
    template: {
      type: Object,
      validator(template) {
        const rules = val => val === undefined || typeof val === 'string';
        const okLabel = rules(template.okLabel);
        const cancelLabel = rules(template.cancelLabel);
        const title = rules(template.dialogTitle);
        const body = rules(template.body);
        const bodyIcon = template.bodyIcon === undefined || typeof template.bodyIcon === 'boolean';
        return okLabel && cancelLabel && title && body && bodyIcon;
      },
    },
    cancelCallback: {
      type: Function,
    },
    okCallback: {
      type: Function,
    },
    csv: {
      type: Object,
      validator(csv) {
        const name = typeof csv.name === 'string';
        const headers = Array.isArray(csv.headers);
        const data = Array.isArray(csv.data) && csv.data.every(item => typeof item === 'object');
        return name && headers && data;
      },
    },
  },
  data() {
    return {
      successIcon,
    };
  },
  methods: {
    cancelClicked() {
      if (this.cancelCallback) this.cancelCallback();
      this.$emit('cancel');
    },
    okClicked() {
      if (this.csv) {
        // const headers = ['machine_name', 'status', 'action'];
        // const data = new Array(10).fill(null).map(req => { return { column1: 'req.agentName', column2: 'req.status', column3: 'req.action'} });
        const { headers } = this.csv;
        const { data } = this.csv;
        this.exportCSV(headers, data, `${Date.now()}-${this.csv.name || ''}`);
      }
      if (this.okCallback) this.okCallback();
      this.$emit('ok');
    },
  },
};
</script>

<style lang="scss" scoped>
.success-dialog-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  min-height: 353px;
  width: 339px;
  overflow: hidden;
}
h2,
h6 {
  line-height: 25px;
  margin: 0;
  text-align: center;
  width: 100%;
}
.dialog-title-wrapper {
  padding-top: 40px;
  padding-bottom: 5px;
  & .ibf-h1 {
    width: 100%;
    text-align: center;
  }
}
.dialog-body-wrapper {
  padding-top: 0;
}
.dialog-btn {
  min-width: 100px;
}
.bottom-gradient {
  position: absolute;
  bottom: 0;
  left: 0%;
  height: 24px;
  width: 100%;
}
.bottom-gradient1 {
  position: absolute;
  height: 24px;
  left: 0%;
  right: -0.23%;
  bottom: 0px;

  background: linear-gradient(90deg, rgba(0, 240, 185, 0.859375) -3.46%, #00f0b9 10.68%, rgba(0, 240, 185, 0) 50.87%);
  opacity: 0.5;
}

.bottom-gradient2 {
  position: absolute;
  height: 17px;
  left: 0%;
  right: 0%;
  bottom: -1px;

  background: linear-gradient(70.93deg, #0bece2 26.54%, #03e8b4 67.13%);
  opacity: 0.8;
}

.warning .bottom-gradient1 {
  background: linear-gradient(90deg, #fff5d1 -3.46%, #ffe895 10.68%, #fff5d1 50.87%);
}

.warning .bottom-gradient2 {
  background: linear-gradient(70.93deg, #ffd02b 26.54%, #fff5d1 67.13%);
}

.danger .bottom-gradient1 {
  background: linear-gradient(90deg, #ffeeee -3.46%, #fba4b3 10.68%, #ffeeee 50.87%);
}

.danger .bottom-gradient2 {
  background: linear-gradient(70.93deg, #eb0028 26.54%, #ffeeee 67.13%);
}

.warning .primary-strong {
  background-color: $-brand-yellow;
}
.warning .secondary {
  color: $-brand-yellow;
}

.danger .primary-strong {
  background-color: $-system-app-error;
}
.danger .secondary {
  color: $-system-app-error;
}

.failure.incredi-button-ibx.primary-strong {
  background-color: $-system-app-grey-22;
}
.failure.incredi-button-ibx.secondary {
  color: $-system-app-grey-22;
}

.primary-strong.disabled,
.danger .primary-strong.disabled,
.warning .primary-strong.disabled {
  background-color: $-status-status-offline;
}
.icon-container {
  display: flex;
  justify-content: center;
}

.action-wrapper {
  align-items: flex-end;
  flex-grow: 1;
  display: flex;
  margin-bottom: 40px;
  width: 100%;
}

.checkbox {
  border: 2px;
  font-size: 13px;
  margin-bottom: 17px;

  :deep(.q-checkbox__bg) {
    color: $-system-app-primary;
  }

  :deep(.q-checkbox__inner--truthy .q-checkbox__bg) {
    color: $-system-app-primary;
  }

  :deep(.q-checkbox__inner:before) {
    background: transparent !important;
  }

  :deep(.q-checkbox__label) {
    color: $-text-text-low-old;
  }
}
.warning .checkbox {
  :deep(.q-checkbox__bg) {
    color: $-brand-yellow;
  }

  :deep(.q-checkbox__inner--truthy .q-checkbox__bg) {
    color: $-brand-yellow;
  }
}

.danger .checkbox {
  :deep(.q-checkbox__bg) {
    color: $-system-app-error;
  }

  :deep(.q-checkbox__inner--truthy .q-checkbox__bg) {
    color: $-system-app-error;
  }
}
</style>
